import {useFormik} from "formik";
import {useDispatch, useSelector,} from "react-redux";
import {workspace} from "@/store/modules/workspace";
import {CreateWorkspaceRequest, WorkspaceRequestInit,} from "@/model/request/workspace/CreateWorkspaceRequest";
import {BaseInput} from "../input/BaseInput";
import {WorkspaceValidation} from "../formik/validation/WorkspaceValidation";
import {RootState} from "@/store/modules";
import {useNavigate} from "react-router-dom";
import {base} from "@/store/modules/base.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {RouteConstant} from "@/util/constant/RouteConstant.ts";

export default function CreateWorkspace() {
    const baseState = useSelector((state: RootState) => state.base)
    const authState = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch<any>();
    const workSpaceData = baseState.modalOptions.payload
    const navigate = useNavigate();
    const workspaceState = useSelector(
        (state: RootState) => state.workspace
    )

    const showMessage = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "success",
                        title: "Success",
                        body: response.responseMessage,
                    })
                )
                dispatch(base.mutation.resetModalOptions())
                dispatch(workspace.action.readWorkSpaceByUserId({userId: authState.userInfo?.userId}));
            }
        );
    };

    const onClose = () => {
        dispatch(base.mutation.resetModalOptions())
    }

    const handleSubmit = async (value: CreateWorkspaceRequest) => {
        await dispatch(workspace.mutation.setCreateWorkSpaceBilling(value))
        navigate(RouteConstant.dashboard.billing.path)
        dispatch(base.mutation.resetModalOptions())
    };
    const updateWorkspace = (value: CreateWorkspaceRequest) => {
        const request = {
            ...value, workspaceId: workSpaceData?.workspaceId,
            workspaceStatus: workSpaceData?.workspaceStatus
        }
        dispatch(workspace.action.updateWorkSpace({
            data: request,
            onSuccess: (response: any) => showMessage(response),
            onError: (response: any) => showMessage(response),
        }))
    };

    const formik = useFormik({
        onSubmit: workSpaceData ? updateWorkspace : handleSubmit,
        initialValues: workSpaceData ? workSpaceData : WorkspaceRequestInit,
        validationSchema: WorkspaceValidation.create,
    });
    return (
            <section>
                <div>
                    <div className="workspace-content">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="workspace-field">
                                <label> Workspace Name</label>
                                <BaseInput
                                    formik={formik}
                                    type="text"
                                    placeholder="Example: My Workspace"
                                    name={"workspaceName"}
                                    className="bg-white"
                                />
                            </div>
                            <div className="workspace-field">
                                <label>Description</label>
                                <BaseInput
                                    formik={formik}
                                    type="text"
                                    placeholder="Description"
                                    name={"workspaceDescription"}
                                    className="bg-white"
                                />
                            </div>
                            <div className="div-block-5" style={{display: "flex", gap: "1rem", justifyContent: "end"}}>
                                <div style={{display:'flex'}} className="form-button-wrpper">
                                    <BaseInput
                                        type="submit"
                                        formik={formik}
                                        className="button w-button "
                                        name={"new"}
                                        loading={workspaceState.loading}
                                        value={workSpaceData ? "Save Changes" : "Create your workspace"}
                                        id="new entity"
                                    />
                                </div>
                                <BaseInput
                                        type="submit"
                                        onClick={onClose}
                                        className="button is-secondary w-button"
                                    
                                        
                                        value={"Cancel"}
                                        id="new entity"
                                    />
                              
                            </div>
                        </form>
                    </div>
                </div>
            </section>
    );
}
